<template>
  <BaseModal name="contractsModal" width="1280" @before-close="beforeCloseModal" @before-open="loadData"
    :clickToClose="false" :shiftY="0.5" :adaptive="true" height="725" classes="bg-system-main-block shadow-none">
    <!-- ШАПКА  -->
    <div class="d-flex justify-content-between px-30 py-5 align-items-center">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div class="d-flex text-dark justify-content-between flex-grow-1 fsc-12" v-if="titleLine">
        <div class="d-flex gap-10 align-items-center">
          <div class="d-flex align-items-center gap-5">
            {{ dataLang["reg_contract_edit_1"]
            }}<span class="fw-medium">{{ titleLine?.contracts__id }}</span>
            {{ dataLang["reg_contract_edit_2"] }}
            <span>
              {{
                $time(titleLine?.contracts__created_at)
                  .utc(true)
                  .utcOffset(Number(userSetting.company__utc))
                  .format(`${userSetting.company__tempalte_date} HH:mm`)
              }}
            </span>
          </div>
          <div class="d-flex align-items-center gap-5">
            <span class="fw-medium"> {{ titleLine?.clients__name }}</span>
            <span>({{ titleLine?.clients__id }})</span>
            {{ dataLang["reg_contract_edit_3"] }}
            <span class="fw-medium">{{
              titleLine?.clients__balance?.replace(".", ",")
            }}</span>
          </div>
        </div>
        <div class="d-flex gap-5 align-items-center fw-bold">
          Длительность:
          {{ dataForModal.contracts__duration }}
          {{ dataLang["reg_contract_edit_4"] }}
        </div>
        <div class="d-flex gap-5 align-items-center pe-30">
          {{ dataLang["reg_contract_edit_7"] }}:
          <span class="fw-medium" v-if="!!dataForModal.contracts_is_simple">
            {{ titleLine?.employee_name }}</span>
          <span class="fw-medium" v-if="!dataForModal.contracts_is_simple">
            Service</span>
          <div class="base-button base-button--action" v-if="!!dataForModal.contracts_is_simple" @click="
            $modal.show('managerContractsModal', {
              id: contractId,
              employee_name: titleLine?.employee_name,
            })
            ">
            {{ dataLang["reg_contract_edit_8"] }}
          </div>
        </div>
      </div>
      <button type="button" class="btn-close p-0 flex-shrink-0" @click="$modal.hide('contractsModal')"></button>
    </div>
    <!-- ШАПКА ТАБОВ -->
    <div class="vue-tabs">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul role="tablist" class="nav nav-tabs">
            <li class="tab" @click="handleTabChange(dataLang['reg_contract_edit_71'])" :class="{
              active: activateTab == dataLang['reg_contract_edit_71'],
            }">
              <a href="#" role="tab" class="tabs__link" :class="{
                active_tab: activateTab == dataLang['reg_contract_edit_71'],
              }"><span class="title title_center">{{
                dataLang["reg_contract_edit_71"]
              }}</span></a>
            </li>
            <li class="tab" @click="handleTabChange(dataLang['reg_contract_edit_72'])" :class="{
              active: activateTab == dataLang['reg_contract_edit_72'],
            }">
              <a href="#" :class="{
                active_tab: activateTab == dataLang['reg_contract_edit_72'],
              }" class="tabs__link"><span class="title title_center">{{
                dataLang["reg_contract_edit_72"]
              }}</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ТАБ ГЛАВНАЯ -->
    <div v-if="activateTab == dataLang['reg_contract_edit_71']" class="pb-10 d-flex gap-10"
      style="height: 588px; padding-left: 27px; padding-right: 27px">
      <!-- Основная информация  -->
      <div class="contracts-modal-block contracts-modal-block--first" style="min-width: 527px; max-width: 527px">
        <div class="contracts-modal-block__additional-desc" v-if="dataForModal.contracts_is_simple">
          Внутренний договор
        </div>
        <div class="contracts-modal-block__additional-desc" v-if="!dataForModal.contracts_is_simple">
          Отраслевой договор.
        </div>
        <div class="contracts-modal-block__body">
          <div class="contracts-modal-block__header" v-if="Object.values(dataForModal).length" :class="{
            'contracts-modal-block__header--reserved':
              dataForModal.contract_statuses__status ==
              'contract_status_reserved',
            'contracts-modal-block__header--archive':
              dataForModal.contract_statuses__status ==
              'contract_status_archive',
            'contracts-modal-block__header--run':
              dataForModal.contract_statuses__status == 'contract_status_run',
            'contracts-modal-block__header--nomoney':
              dataForModal.contract_statuses__status ==
              'contract_status_nomoney',
            'contracts-modal-block__header--blocked':
              dataForModal.contract_statuses__status ==
              'contract_status_blocked',
            'contracts-modal-block__header--return':
              dataForModal.contract_statuses__status ==
              'contract_status_return',
            'text-white':
              dataForModal.contract_statuses__status ==
              'contract_status_nomoney' ||
              dataForModal.contract_statuses__status ==
              'contract_status_run' ||
              dataForModal.contract_statuses__status ==
              'contract_status_blocked' ||
              dataForModal.contract_statuses__status ==
              'contract_status_return',
          }">
            {{
              dataLang[dataForModal.contract_statuses__status]
                .charAt(0)
                .toUpperCase() +
              dataLang[dataForModal.contract_statuses__status].slice(1)
            }}
          </div>
          <div class="contracts-modal-block__content">
            <!-- АРЕНДАТОР  -->
            <div class="d-flex gap-5" style="margin-bottom: 7px">
              <BaseInputNew placeholder="" width="311" class="" signClass="text-dark" disabled
                input-name="clients__name" :horizontalTitle="true" :value="dataForModal.clients__name"
                :additionalParams="{}" :name-sign="dataLang['reg_contract_edit_9']">
              </BaseInputNew>
              <BaseInputNew placeholder="" width="121" inputClass="text-center" disabled input-name="clients__phone"
                :value="dataForModal.clients__phone" :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
            <!-- ВОДИТЕЛЬ 1  -->
            <div class="d-flex gap-5 align-items-center" style="margin-bottom: 7px">
              <div class="fsc-11 text-dark flex-grow-1">
                {{ dataLang["reg_contract_edit_10"] }}
              </div>
              <BaseSelect :disabled="!!dataForModal.contracts__is_object_out" style="width: 311px" placeholder=""
                :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                  (data) => {
                    setUpdateSelect(
                      data.clients__id,
                      'contracts__client_driver1_id'
                    );
                  }
                " v-model="selectValues.firstDriver" label="clients__name" :options="selectOptions.drivers">
              </BaseSelect>
              <BaseInputNew placeholder="" width="121" inputClass="text-center" disabled
                :value="selectValues.firstDriver?.clients__phone" :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
            <!-- ВОДИТЕЛЬ 2  -->
            <div class="d-flex gap-5 align-items-center" style="margin-bottom: 7px">
              <div class="fsc-11 text-dark flex-grow-1">
                {{ dataLang["reg_contract_edit_11"] }}
              </div>
              <BaseSelect :disabled="!!dataForModal.contracts__is_object_out" style="width: 311px" placeholder=""
                :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                  (data) => {
                    setUpdateSelect(
                      data.clients__id,
                      'contracts__client_driver2_id'
                    );
                  }
                " v-model="selectValues.secondDriver" label="clients__name" :options="selectOptions.drivers">
              </BaseSelect>
              <BaseInputNew placeholder="" width="121" inputClass="text-center" disabled
                :value="selectValues.secondDriver?.clients__phone" :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
            <!-- ОБЪЕКТ И ТАРИФ  -->
            <div class="d-flex gap-5 align-items-center" style="margin-bottom: 7px">
              <div class="fsc-11 text-dark flex-grow-1">
                {{ dataLang["reg_contract_edit_12"] }}
              </div>
              <BaseSelect :class="{
                'flag-block':
                  !!dataForModal.contracts_is_simple &&
                  !dataForModal.contracts__is_object_out,
              }" :disabled="!dataForModal.contracts_is_simple ||
                !!dataForModal.contracts__is_object_out
                " style="width: 249px" placeholder="" :showNoOptions="false" :showNoResults="false" selectLabel=""
                deselectLabel="" @input="
                  (data) => {
                    setUpdateSelect(data.vehicles__id, 'contracts__vehicle_id');
                  }
                " v-model="selectValues.contracts__vehicle_id" :customLabel="({ vehicles__name, vehicles__id, vehicles__gosnumber }) =>
                  `${vehicles__name} ${vehicles__gosnumber} (id ${vehicles__id})`
                  " :options="selectOptions.contracts__vehicle_id">
              </BaseSelect>
              <div class="d-flex gap-5 align-items-center">
                <div style="display: flex; gap: 2px; align-items: center">
                  <div class="fsc-11">
                    {{ dataLang["reg_contract_edit_13"] }}
                  </div>
                  <img @click="
                    $modal.show('tariffQuestionModal', {
                      contracts__id: contractId,
                    })
                    " :src="require(`@/assets/icons/question.svg`)" class="cursor-pointer" width="12" height="12" />
                </div>
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="40" inputClass="text-center px-0" input-name="contracts__current_t_cost"
                  @input="updateInputAndCheckboxValue" :value="dataForModal.contracts__current_t_cost"
                  :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
            </div>
            <!-- ДЕТСКОЕ КРЕСЛО И ТАРИФ АРЕНДЫ ДЕТСКОГО КРЕСЛА  -->
            <div class="d-flex gap-5 align-items-center justify-content-between" style="margin-bottom: 7px">
              <div class="d-flex gap-5">
                <BaseCheckboxV2 :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!!dataForModal.contracts__is_object_out" placeholder="" class="" boxClass="bg-white"
                  input-name="contracts__is_child_seat" v-model="dataForModal.contracts__is_child_seat"
                  @oncheckeds="updateInputAndCheckboxValue">
                  <span class="text-dark">{{
                    dataLang["reg_contract_edit_14"]
                  }}</span>
                </BaseCheckboxV2>
                <BaseSelect :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!!dataForModal.contracts__is_object_out" style="width: 41px" placeholder=""
                  :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                    (data) => {
                      setUpdateSelect(
                        data.label,
                        'contracts__count_seats_child'
                      );
                    }
                  " v-model="selectValues.contracts__count_seats_child" label="label"
                  :options="selectOptions.contracts__count_seats_child">
                </BaseSelect>
              </div>
              <div class="d-flex gap-5">
                <div style="display: flex; gap: 2px; align-items: center">
                  <div class="fsc-11">
                    {{ dataLang["reg_contract_edit_15"] }}
                  </div>
                  <img class="cursor-pointer" @click="
                    $modal.show('questionModal', {
                      text: dataLang['reg_contract_modal_100'],
                    })
                    " :src="require(`@/assets/icons/question.svg`)" width="12" height="12" />
                </div>
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="40" inputClass="text-center px-0"
                  input-name="contracts__current_t_child_seat_cost" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__current_t_child_seat_cost" :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
            </div>
            <!-- ЗАЛОГ И ЦЕНА ЗАЛОГА  -->
            <div class="d-flex gap-5 align-items-center justify-content-between" style="margin-bottom: 7px">
              <div class="d-flex align-items-center" style="gap: 2px">
                <BaseCheckboxV2 :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out ||
                  !!dataForModal.clients__is_pledge_only
                  " placeholder="" class=" " boxClass="bg-white" input-name="contracts__is_pledge"
                  v-model="dataForModal.contracts__is_pledge" @oncheckeds="updateInputAndCheckboxValue">
                  <span class="text-dark">{{
                    dataLang["reg_contract_edit_16"]
                  }}</span>
                </BaseCheckboxV2>
                <img class="cursor-pointer" @click="
                  $modal.show('questionModal', {
                    text: dataLang['reg_contract_modal_101'],
                  })
                  " :src="require(`@/assets/icons/question.svg`)" width="12" height="12" />
              </div>
              <div class="d-flex gap-5">
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="40" inputClass="text-center px-0"
                  input-name="contracts__current_t_pledge_cost" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__current_t_pledge_cost" :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
            </div>
            <!-- ДЕПОЗИТ И ЦЕНА ДЕПОЗИТА  -->
            <div class="d-flex gap-5 align-items-center justify-content-between" style="margin-bottom: 7px">
              <div class="d-flex align-items-center" style="gap: 2px">
                <BaseCheckboxV2 :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" disabled class=" " boxClass="bg-white" input-name="contracts__is_deposit"
                  v-model="dataForModal.contracts__is_deposit" @oncheckeds="updateInputAndCheckboxValue">
                  <span class="text-muted">{{
                    dataLang["reg_contract_edit_17"]
                  }}</span>
                </BaseCheckboxV2>
                <img class="cursor-pointer" @click="
                  $modal.show('questionModal', {
                    text: dataLang['reg_contract_modal_102'],
                  })
                  " :src="require(`@/assets/icons/question.svg`)" width="12" height="12" />
              </div>
              <div class="d-flex gap-5">
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="40" inputClass="text-center px-0"
                  input-name="contracts__current_t_deposit_cost" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__current_t_deposit_cost" :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
            </div>
            <!-- РАЗДЕЛИТЕЛЬ  -->
            <div class="bg-disabled wp-100" style="height: 1px"></div>
            <!-- ОБЩАЯ ИНФА О ПРОБЕГЕ  -->
            <div class="py-5 d-flex gap-5 align-items-center">
              <!-- ПРЕДВАРИТЕЛЬНЫЙ ПРОБЕГ  -->
              <div class="" style="gap: 4px" ref="contracts__predicted_run">
                <div class="fsc-11">{{ dataLang["reg_contract_edit_18"] }}</div>

                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!!dataForModal.contracts__is_object_out" placeholder="" width="97"
                  inputClass="text-center" input-name="contracts__predicted_run" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__predicted_run" :additionalParams="{}" name-sign="">
                </BaseInputNew>
                <div class="fsc-11 text-danger text-center" style="height: 16.5px">
                  <span v-if="dataForModal.contracts__overrun > 0">п/п {{ dataForModal.contracts__overrun }}</span>
                </div>
              </div>
              <!-- КНОПКА "РАССЧИТАТЬ"  -->
              <a href="https://news.cigarexpert.ru/" target="_blank" class="contracts-blue-btn">
                {{ dataLang["reg_contract_edit_19"] }}
              </a>
              <!-- ПРЕДВАРИТЕЛЬНЫЙ ПРОБЕГ  -->
              <div class="" style="gap: 4px">
                <div class="fsc-11 text-center text-muted">
                  {{ dataLang["reg_contract_edit_20"] }}
                </div>
                <BaseInputNew :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="102" inputClass="text-center" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__allowed_run" :additionalParams="{}" disabled name-sign="">
                </BaseInputNew>
                <div class="fsc-11 text-muted text-center">
                  ({{ dataForModal.contracts__duration }}*{{
                    dataForModal.contracts__current_t_allowed_day_km
                  }}
                  {{ dataLang["reg_contract_edit_22"] }})
                </div>
              </div>
              <div class="d-flex flex-column justify-content-between gap-10 ps-10">
                <div class="d-flex gap-5 align-items-center justify-content-between">
                  <div style="display: flex; gap: 2px; align-items: center">
                    <div class="fsc-11">
                      {{ dataLang["reg_contract_edit_23"]
                      }}{{ dataLang["reg_contract_edit_22"] }}
                    </div>
                    <img :src="require(`@/assets/icons/question.svg`)" @click="
                      $modal.show('questionModal', {
                        text: dataLang['reg_contract_modal_103'],
                      })
                      " class="cursor-pointer" width="12" height="12" />
                  </div>
                  <BaseInputNew :class="{
                    'flag-block':
                      !!dataForModal.contracts_is_simple &&
                      !dataForModal.contracts__is_object_out,
                  }" :disabled="!dataForModal.contracts_is_simple ||
                    !!dataForModal.contracts__is_object_out
                    " placeholder="" width="40" inputClass="text-center px-0"
                    input-name="contracts__current_t_allowed_day_km" @input="updateInputAndCheckboxValue"
                    :value="dataForModal.contracts__current_t_allowed_day_km" :additionalParams="{}" name-sign="">
                  </BaseInputNew>
                </div>
                <div class="d-flex gap-5 align-items-center justify-content-between">
                  <div style="display: flex; gap: 2px; align-items: center">
                    <div class="fsc-11">
                      {{ dataLang["reg_contract_edit_24"] }}
                    </div>
                    <img :src="require(`@/assets/icons/question.svg`)" @click="
                      $modal.show('questionModal', {
                        text: dataLang['reg_contract_modal_104'],
                      })
                      " class="cursor-pointer" width="12" height="12" />
                  </div>
                  <BaseInputNew :class="{
                    'flag-block':
                      !!dataForModal.contracts_is_simple &&
                      !dataForModal.contracts__is_object_out,
                  }" :disabled="!dataForModal.contracts_is_simple ||
                    !!dataForModal.contracts__is_object_out
                    " placeholder="" width="40" inputClass="text-center px-0"
                    input-name="contracts__current_t_one_km_cost" @input="updateInputAndCheckboxValue"
                    :value="dataForModal.contracts__current_t_one_km_cost" :additionalParams="{}" name-sign="">
                  </BaseInputNew>
                </div>
              </div>
            </div>
            <!-- РАЗДЕЛИТЕЛЬ  -->
            <div class="bg-disabled wp-100" style="height: 1px"></div>
            <!-- Программа страхования аренды  -->
            <div class="py-5">
              <!-- Частичная Программа страхования аренды  -->
              <div class="d-flex gap-5 align-items-center mb-5">
                <div class="d-flex gap-5 align-items-center flex-grow-1">
                  <BaseRadio :disabled="!!dataForModal.contracts__is_object_out" inputName="contracts__current_t_is_fr"
                    name="contracts__current_t_is_fr" value="1" @change="updateRadioInsuranse"
                    v-model="dataForModal.contracts__current_t_is_fr">
                    <div class="fsc-11">
                      {{ dataLang["reg_contract_edit_26"] }}
                    </div>
                  </BaseRadio>
                  <img :src="require(`@/assets/icons/question.svg`)" @click="
                    $modal.show('questionModal', {
                      text: dataLang['reg_contract_modal_105'],
                    })
                    " class="cursor-pointer" width="12" height="12" />
                </div>
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="40" inputClass="text-center px-0" input-name="contracts__current_t_fr_cost"
                  @input="updateInputAndCheckboxValue" :value="dataForModal.contracts__current_t_fr_cost"
                  :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
              <!-- Полная Программа страхования аренды  -->
              <div class="d-flex gap-5 align-items-center">
                <div class="d-flex gap-5 align-items-center flex-grow-1">
                  <BaseRadio :disabled="!!dataForModal.contracts__is_object_out"
                    inputName="contracts__current_t_is_fr_day" name="contracts__current_t_is_fr_day" value="1"
                    @change="updateRadioInsuranse" v-model="dataForModal.contracts__current_t_is_fr_day">
                    <div class="fsc-11">
                      {{ dataLang["reg_contract_edit_27"] }}
                    </div>
                  </BaseRadio>
                  <img :src="require(`@/assets/icons/question.svg`)" @click="
                    $modal.show('questionModal', {
                      text: dataLang['reg_contract_modal_106'],
                    })
                    " class="cursor-pointer" width="12" height="12" />
                </div>
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!dataForModal.contracts_is_simple ||
                  !!dataForModal.contracts__is_object_out
                  " placeholder="" width="40" inputClass="text-center px-0"
                  input-name="contracts__current_t_fr_day_cost" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__current_t_fr_day_cost" :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
            </div>
            <!-- РАЗДЕЛИТЕЛЬ  -->
            <div class="bg-disabled wp-100" style="height: 1px"></div>
            <!-- АДРЕСА И РЕГИОНЫ  -->
            <div class="py-5">
              <!-- Основной адрес ночной стоянки объекта  -->
              <div class="d-flex gap-5 mb-5 align-items-center" ref="contracts__address">
                <div class="d-flex align-items-center flex-grow-1" style="gap: 3px">
                  <div class="fsc-12 fw-medium">
                    {{ dataLang["reg_contract_edit_28"] }}
                  </div>
                  <img :src="require(`@/assets/icons/question.svg`)" @click="
                    $modal.show('questionModal', {
                      text: dataLang['reg_contract_modal_107'],
                    })
                    " class="cursor-pointer" width="12" height="12" />
                </div>
                <BaseInputNew :class="{
                  'flag-block':
                    !!dataForModal.contracts_is_simple &&
                    !dataForModal.contracts__is_object_out,
                }" :disabled="!!dataForModal.contracts__is_object_out" placeholder="" width="242" inputClass=""
                  input-name="contracts__address" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__address" :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
              <div class="d-flex gap-5 align-items-center">
                <div class="d-flex gap-5 align-items-center flex-grow-1">
                  <div class="fsc-12 fw-medium">
                    {{ dataLang["reg_contract_edit_29"] }}
                  </div>
                  <img :src="require(`@/assets/icons/question.svg`)" @click="
                    $modal.show('questionModal', {
                      text: dataLang['reg_contract_modal_108'],
                    })
                    " class="cursor-pointer" width="12" height="12" />
                  <div class="error-area d-flex align-items-center" style="height: 26px; width: 323px"
                    ref="contracts__regions">
                    <div class="fsc-11 ps-5" style="
                        width: 323px;
                        overflow-x: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      ">
                      <span v-for="(item, index) of regionsListData" :key="item.contract_regions__region_id">{{
                        item.regions__name
                      }}<span v-if="index !== regionsListData.length - 1">,
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bg-opposite rounded-5 d-flex cursor-pointer" style="width: 24px; height: 24px" @click="
                  $modal.show('regionsContractsModal', {
                    contracts__id: dataForModal.contracts__id,
                  })
                  ">
                  <img :src="require(`@/assets/icons/gear.svg`)" class="m-auto" width="16" height="16" />
                </div>
              </div>
            </div>
            <!-- РАЗДЕЛИТЕЛЬ  -->
            <div class="bg-disabled wp-100" style="height: 1px"></div>
            <!-- СПИСОК КНОПОК НА СКАЧИВАНИЕ ПДФ  -->
            <div class="pb-5 position-relative">
              <div class="text-center fsc-12 fw-medium mb-10">
                {{ dataLang["reg_contract_edit_30"] }}
              </div>
              <!-- {{ computedIsUpdatedData }} -->
              <div class="d-flex gap-10">
                <div class="bg-opposite py-5 px-10 fsc-11 lh-1 rounded-5 cursor-pointer">
                  {{ dataLang["reg_contract_edit_31"] }}
                </div>
                <div class="bg-opposite py-5 px-10 fsc-11 lh-1 rounded-5 cursor-pointer">
                  {{ dataLang["reg_contract_edit_32"] }}
                </div>
                <div class="bg-opposite py-5 px-10 fsc-11 lh-1 rounded-5 cursor-pointer">
                  {{ dataLang["reg_contract_edit_33"] }}
                </div>
                <div class="bg-opposite py-5 px-10 fsc-11 lh-1 rounded-5 cursor-pointer">
                  {{ dataLang["reg_contract_edit_34"] }}
                </div>
                <div class="bg-opposite py-5 px-10 fsc-11 lh-1 rounded-5 cursor-pointer">
                  {{ dataLang["reg_contract_edit_35"] }}
                </div>
              </div>
              <div v-if="isUpdatedData" @click="saveModal(true, false)" class="bg-danger" style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  font-weight: bold;
                  color: white;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                Внесены изменения! Нажмите, чтобы пересчитать договор!
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Начало аренды  -->
      <div class="contracts-modal-block contracts-modal-block--start-rent" style="min-width: 223px; max-width: 223px"
        :style="{
          height: !dataForModal.contracts__is_issuance_confirmed_client
            ? 'min-content'
            : '',
        }">
        <div class="contracts-modal-block__header">
          {{ dataLang["reg_contract_main_29"] }}
        </div>
        <div class="contracts-modal-block__body pb-5">
          <div class="fsc-9 text-center" style="margin-bottom: 5px; margin-top: 3px">
            {{ dataLang["reg_contract_edit_37"] }}
          </div>
          <!-- ДАТА НАЧАЛА АРЕНДЫ  -->
          <BaseDatePicker :class="{ 'flag-block': !dataForModal.contracts__is_object_out }" :minute-step="15"
            time-title-format="DD.MM.YYYY" :disabled="!!dataForModal.contracts__is_object_out"
            :disabled-date="notBeforeToday" style="width: 100%; margin-bottom: 8px"
            v-model="dataForModal.contracts__starts" :clearable="false" type="datetime"
            class="fsc-11 idiots-class-for-input-date" lang="ru" :format="`${userSetting.company__tempalte_date} HH:mm`"
            value-type="format" @change="
              (date) =>
                updateInputAndCheckboxValue({
                  name: 'contracts__starts',
                  value: calculateInputDate(date, 'send'),
                })
            ">
          </BaseDatePicker>
          <div class="fsc-12 fw-bolder base-button wp-100" @click="
            $modal.show('confirmedIssueAndRevertModal', {
              contracts__id: contractId,
              typeAccept: 'issuance',
              additionalDate: calculateInputDate(
                dataForModal.contracts__starts,
                'send'
              ),
            })
            " style="padding: 5px 0; margin-bottom: 8px" v-if="!dataForModal.contracts__is_issuance_confirmed_client">
            {{ dataLang["reg_contract_edit_40"] }}
          </div>
          <div class="fsc-12 fw-bolder text-center text-muted wp-100" style="padding: 7px 0; margin-bottom: 8px"
            v-if="dataForModal.contracts__is_issuance_confirmed_client">
            {{ dataLang["reg_contract_edit_40"] }}
          </div>
          <!-- ДАТА ТАРИФА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center" style="margin-bottom: 8px">
            <div class="d-flex align-items-center" style="gap: 2px">
              <div class="fsc-11">{{ dataLang["reg_contract_edit_41"] }}</div>
              <img class="cursor-pointer" @click="
                $modal.show('questionModal', {
                  text:
                    dataLang['reg_contract_modal_110'] ??
                    'Сириус вычисляет тариф не по длительности аренды (между датами начала и завершения), а по длительности между датами “Тариф от” и “Дата завершения”. При создании договора, дата “Тариф от” автоматически копирует дату “Начала”. Однако, в случае эстафетной аренды (клиент «пересел» с одного объекта на другой) это будет некорректно. Если клиент арендует Kia Rio с 1.01 по 31.01 на 30 суток – Сириус назначит договору самый низкий тариф “Т9”. Допустим, Kia Rio сломалась 30.01 и вы предложили клиенту “докатать” последние сутки на свободном BMW X1. Вы принимаете Kia Rio и сразу создаете новый договор аренды на BMW X1 на 1 сутки. По какому тарифу клиент арендует подменную BMW X1? По дорогому Т1 (1 сутки)? Нет, по дешевому Т9, так как клиент «пересел» на вашу BMW X1 с вашей же Kia Rio, которую арендовал еще 1.01. Поэтому в договоре аренды на BMW X1 правильными будут даты: Начало: 30.01, Завершение: 31.01, Тариф от: 01.01',
                })
                " :src="require(`@/assets/icons/question.svg`)" width="12" height="12" />
            </div>
            <BaseDatePicker :class="{ 'flag-block': !dataForModal.contracts__is_object_out }"
              time-title-format="DD.MM.YYYY" :disabled-date="notAfterDateStart"
              :disabled="!!dataForModal.contracts__is_object_out" style="width: 145px"
              v-model="dataForModal.contracts__tariff_from" :clearable="false" type="date"
              class="fsc-11 idiots-class-for-input-date" lang="ru" :format="`${userSetting.company__tempalte_date}`"
              value-type="format" @change="
                (date) =>
                  updateInputAndCheckboxValue({
                    name: 'contracts__tariff_from',
                    value: calculateInputDate(date + ' ' + '00:00', 'send'),
                  })
              ">
            </BaseDatePicker>
          </div>
          <!-- ГОРОД НАЧАЛА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_42"] }}</div>

            <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_out }"
              :disabled="!!dataForModal.contracts__is_object_out" style="width: 145px" placeholder=""
              :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel=""
              @open="() => getCitiesList('start')" @input="
                (data) => {
                  setUpdateSelect(
                    data.cities__id,
                    'contracts__city_start_id',
                    true
                  );
                }
              " v-model="selectValues.contracts__city_start_id" label="cities__name"
              :options="selectOptions.contracts__city_start_id" :maxHeight="400">
            </BaseSelect>
          </div>
          <!-- ПЛОЩАДКА НАЧАЛА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center"
            :title="selectValues?.contracts__place_start_id?.address" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_43"] }}</div>
            <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_out }"
              :disabled="!!dataForModal.contracts__is_object_out" style="width: 145px" placeholder=""
              :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                (data) => {
                  setUpdateSelect(data.id, 'contracts__place_start_id');
                }
              " v-model="selectValues.contracts__place_start_id" label="address"
              :options="selectOptions.contracts__place_start_id" :maxHeight="400">
            </BaseSelect>
          </div>
          <!-- ДОСТАВКА НАЧАЛА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_44"] }}</div>
            <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_out }"
              :disabled="!!dataForModal.contracts__is_object_out" style="width: 145px" placeholder=""
              :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                (data) => {
                  setUpdateSelect(data.id, 'contracts__delivery_start_id');
                }
              " v-model="selectValues.contracts__delivery_start_id" label="address"
              :options="selectOptions.contracts__delivery_start_id" :maxHeight="400">
            </BaseSelect>
          </div>
          <!-- КОММЕНТАРИЙ НАЧАЛА  -->
          <div class="wp-100">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_45"] }}</div>
            <BaseInputNew :disabled="!!dataForModal.contracts__is_object_out" placeholder="" width="210"
              input-name="contracts__delivery_start_comment" @input="updateInputAndCheckboxValue"
              :value="dataForModal.contracts__delivery_start_comment" :additionalParams="{}" name-sign="">
            </BaseInputNew>
          </div>
        </div>
        <div v-if="dataForModal.contracts__is_issuance_confirmed_client"
          style="padding: 2px 0; background-color: #0c63aa" class="fsc-12 fw-medium text-center text-white">
          {{ dataLang["reg_contract_edit_52"] }}
        </div>
        <!-- ОДОМЕТР И ТОПЛИВО  -->
        <div v-if="dataForModal.contracts__is_issuance_confirmed_client" class="contracts-modal-block__body"
          style="padding: 5px 10px 20px 10px">
          <div class="d-flex justify-content-between">
            <div class="d-flex gap-5 align-items-center" ref="contracts__odometr_start">
              <div style="display: flex; gap: 5px; align-items: center">
                <div class="fsc-11">{{ dataLang["reg_contract_edit_53"] }}</div>
              </div>
              <BaseInputNew :class="{
                'flag-block': !dataForModal.contracts__is_object_out,
              }" :disabled="!!dataForModal.contracts__is_object_out" placeholder="" width="57" inputClass="text-center"
                input-name="contracts__odometr_start" @input="updateInputAndCheckboxValue"
                :value="dataForModal.contracts__odometr_start" :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
            <div class="d-flex gap-5 align-items-center" ref="contracts__fuel_start_liter">
              <div style="display: flex; gap: 5px; align-items: center">
                <div class="fsc-11">{{ dataLang["reg_contract_edit_54"] }}</div>
              </div>
              <BaseInputNew :class="{
                'flag-block': !dataForModal.contracts__is_object_out,
              }" :disabled="!!dataForModal.contracts__is_object_out" placeholder="" width="29" inputClass="text-center"
                input-name="contracts__fuel_start_liter" @input="updateInputAndCheckboxValue"
                :value="dataForModal.contracts__fuel_start_liter" :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
          </div>
        </div>
        <div v-if="dataForModal.contracts__is_issuance_confirmed_client"
          style="padding: 2px 0; background-color: #0c63aa" class="fsc-12 fw-medium text-center text-white">
          {{ dataLang["reg_contract_edit_55"] }}
        </div>
        <!-- Грязное при выдаче  -->
        <div v-if="dataForModal.contracts__is_issuance_confirmed_client" class="contracts-modal-block__body"
          style="padding: 9px 10px">
          <div class="d-flex gap-5" style="margin-bottom: 9px">
            <!-- Элементы кузова  -->
            <div class="d-flex flex-column" style="gap: 4px">
              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out" v-if="washData?.washing_type_body"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__start_state"
                v-model="washData.washing_type_body.contract_washings__start_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_body,
                        'start',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_body.washing_types__name]
                }}</span>
              </BaseCheckboxV2>
              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out" v-if="washData?.washing_type_carpets"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__start_state"
                v-model="washData.washing_type_carpets.contract_washings__start_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_carpets,
                        'start',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_carpets.washing_types__name]
                }}</span>
              </BaseCheckboxV2>

              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out" v-if="washData?.washing_type_salon"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__start_state"
                v-model="washData.washing_type_salon.contract_washings__start_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_salon,
                        'start',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_salon.washing_types__name]
                }}</span>
              </BaseCheckboxV2>

              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out" v-if="washData?.washing_type_trunk"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__start_state"
                v-model="washData.washing_type_trunk.contract_washings__start_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_trunk,
                        'start',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_trunk.washing_types__name]
                }}</span>
              </BaseCheckboxV2>
            </div>
            <!-- Данные химчистки  -->
            <div class="d-flex flex-column" style="gap: 4px">
              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out" placeholder="" class=""
                boxClass="bg-white" input-name="start" v-model="washAllSelect.start" style="gap: 3px"
                @oncheckeds="(data) => selectAllWashType(data, 'start')">
                <span class="text-dark">{{
                  dataLang["reg_contract_edit_60"]
                }}</span>
              </BaseCheckboxV2>
              <div class="d-flex">
                <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out"
                  v-if="washData?.washing_type_dryclean_seats" placeholder="" class="" boxClass="bg-white"
                  style="gap: 3px" input-name="contract_washings__start_state" v-model="washData.washing_type_dryclean_seats
                    .contract_washings__start_state
                    " @oncheckeds="
                      (data) =>
                        updateWashData(
                          washData.washing_type_dryclean_seats,
                          'start',
                          data.value
                        )
                    ">
                  <span class="text-dark">{{
                    dataLang[
                    washData.washing_type_dryclean_seats.washing_types__name
                    ]
                    }}</span>
                </BaseCheckboxV2>
                &nbsp;
                <BaseSelect :disabled="!!dataForModal.contracts__is_object_out"
                  v-if="washData?.washing_type_dryclean_seats" style="width: 36px" placeholder="" :showNoOptions="false"
                  :showNoResults="false" selectLabel="" deselectLabel="" @input="
                    (data) => {
                      updateWashData(
                        washData.washing_type_dryclean_seats,
                        'start',
                        data.value,
                        true
                      );
                    }
                  " v-model="washData.washing_type_dryclean_seats
                    .contract_washings__start_count
                    " label="label" :options="listCountSeatsForSelect" :maxHeight="150">
                </BaseSelect>
              </div>
              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out"
                v-if="washData?.washing_type_dryclean_ceiling" placeholder="" class="" boxClass="bg-white"
                style="gap: 3px" input-name="contract_washings__start_state" v-model="washData.washing_type_dryclean_ceiling
                  .contract_washings__start_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_dryclean_ceiling,
                        'start',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[
                  washData.washing_type_dryclean_ceiling.washing_types__name
                  ]
                  }}</span>
              </BaseCheckboxV2>
              <BaseCheckboxV2 :disabled="!!dataForModal.contracts__is_object_out"
                v-if="washData?.washing_type_dryclean_floor" placeholder="" class="" boxClass="bg-white"
                style="gap: 3px" input-name="contract_washings__start_state" v-model="washData.washing_type_dryclean_floor
                  .contract_washings__start_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_dryclean_floor,
                        'start',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[
                  washData.washing_type_dryclean_floor.washing_types__name
                  ]
                  }}</span>
              </BaseCheckboxV2>
            </div>
          </div>
          <div class="fsc-12 fw-bolder base-button wp-100" @click="
            $modal.show('confirmedIssueAndRevertModal', {
              contracts__id: contractId,
              typeAccept: 'out',
              additionalDate: calculateInputDate(
                dataForModal.contracts__starts,
                'send'
              ),
            })
            " style="padding: 5px 0" v-if="!dataForModal.contracts__is_object_out">
            {{ dataLang["reg_contract_edit_64"] }}
          </div>
          <div class="fsc-12 fw-bolder text-center text-muted wp-100" style="padding: 5px 0"
            v-if="dataForModal.contracts__is_object_out">
            {{ dataLang["reg_contract_edit_64"] }}
          </div>
        </div>
      </div>
      <!-- Конец аренды  -->
      <div class="contracts-modal-block contracts-modal-block--end-rent" style="min-width: 223px; max-width: 223px"
        :style="{
          height: !dataForModal.contracts__is_revert_confirmed_client
            ? 'min-content'
            : '',
        }">
        <div class="contracts-modal-block__header">
          {{ dataLang["reg_contract_edit_46"] }}
        </div>
        <div class="contracts-modal-block__body pb-5">
          <div class="fsc-9 text-center" style="margin-bottom: 5px; margin-top: 3px">
            {{ dataLang["reg_contract_edit_37"] }}
          </div>
          <!-- ДАТА КОНЦА АРЕНДЫ  -->
          <BaseDatePicker :class="{ 'flag-block': !dataForModal.contracts__is_object_in }" :minute-step="15"
            time-title-format="DD.MM.YYYY" :disabled="!dataForModal.contracts__is_editable"
            :disabled-date="notBeforeStart" style="width: 100%; margin-bottom: 8px"
            v-model="dataForModal.contracts__ends" :clearable="false" type="datetime"
            class="fsc-11 idiots-class-for-input-date" lang="ru" :format="`DD.MM.YYYY HH:mm`" value-type="format"
            @change="
              (date) =>
                updateInputAndCheckboxValue({
                  name: 'contracts__ends',
                  value: calculateInputDate(date, 'send'),
                })
            ">
          </BaseDatePicker>
          <div style="height: 32px; margin-bottom: 8px" v-if="!dataForModal.contracts__is_object_out"></div>
          <div class="fsc-12 fw-bolder base-button wp-100" @click="
            $modal.show('confirmedIssueAndRevertModal', {
              contracts__id: contractId,
              typeAccept: 'revert',
              additionalDate: calculateInputDate(
                dataForModal.contracts__ends,
                'send'
              ),
            })
            " style="padding: 5px 0; margin-bottom: 8px" v-if="
              !dataForModal.contracts__is_revert_confirmed_client &&
              dataForModal.contracts__is_object_out
            ">
            {{ dataLang["reg_contract_edit_110"] }}
          </div>
          <div class="fsc-12 fw-bolder text-center text-muted wp-100" style="padding: 7px 0; margin-bottom: 8px"
            v-if="dataForModal.contracts__is_revert_confirmed_client">
            {{ dataLang["reg_contract_edit_110"] }}
          </div>
          <!-- ДАТА ТАРИФА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_48"] }}</div>
            <div class="d-flex gap-5">
              <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_in }"
                :disabled="!dataForModal.contracts__is_editable" :style="{
                  width:
                    selectValues.contracts__prolongation_type_id
                      .contract_prolongations_types__id == 1
                      ? '93px'
                      : '145px',
                }" placeholder="" :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                  (data) => {
                    setUpdateSelect(
                      data.contract_prolongations_types__id,
                      'contracts__prolongation_type_id'
                    );
                  }
                " v-model="selectValues.contracts__prolongation_type_id" :custom-label="({ contract_prolongations_types__type }) =>
                  dataLang[contract_prolongations_types__type]
                  " :options="selectOptions.contracts__prolongation_type_id" :maxHeight="200">
              </BaseSelect>
              <!-- v-if="selectValues.contracts__prolongation_type_id.contract_prolongations_types__id == 1" -->
              <BaseDatePicker :disabled-date="notBeforeSpecificDate" v-if="
                selectValues.contracts__prolongation_type_id
                  .contract_prolongations_types__id == 1
              " :class="{ 'flag-block': !dataForModal.contracts__is_object_in }" title-format="DD.MM.YYYY HH:mm"
                :disabled="!dataForModal.contracts__is_editable" style="width: 69px"
                v-model="dataForModal.contracts__prolongation_date" :clearable="false" type="date"
                class="fsc-11 idiots-class-for-input-date" lang="ru" input-class="pe-5 mx-input"
                :format="`${userSetting.company__tempalte_date}`" value-type="format" @change="
                  (date) =>
                    updateInputAndCheckboxValue({
                      name: 'contracts__prolongation_date',
                      value: date.split('.').reverse().join('-'),
                    })
                ">
                <template #icon-calendar>
                  <div></div>
                </template>
              </BaseDatePicker>
            </div>
          </div>
          <!-- ГОРОД КОНЦА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_42"] }}</div>
            <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_in }"
              :disabled="!dataForModal.contracts__is_editable" style="width: 145px" placeholder=""
              :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel=""
              @open="() => getCitiesList('end')" @input="
                (data) => {
                  setUpdateSelect(
                    data.cities__id,
                    'contracts__city_end_id',
                    true
                  );
                }
              " v-model="selectValues.contracts__city_end_id" label="cities__name"
              :options="selectOptions.contracts__city_end_id" :maxHeight="400">
            </BaseSelect>
          </div>
          <!-- ПЛОЩАДКА КОНЦА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center"
            :title="selectValues?.contracts__place_end_id?.address" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_43"] }}</div>
            <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_in }"
              :disabled="!dataForModal.contracts__is_editable" style="width: 145px" placeholder=""
              :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                (data) => {
                  setUpdateSelect(data.id, 'contracts__place_end_id');
                }
              " v-model="selectValues.contracts__place_end_id" label="address"
              :options="selectOptions.contracts__place_end_id" :maxHeight="400">
            </BaseSelect>
          </div>
          <!-- ДОСТАВКА КОНЦА  -->
          <div class="wp-100 d-flex justify-content-between align-items-center" style="margin-bottom: 8px">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_44"] }}</div>
            <BaseSelect :class="{ 'flag-block': !dataForModal.contracts__is_object_in }"
              :disabled="!dataForModal.contracts__is_editable" style="width: 145px" placeholder=""
              :showNoOptions="false" :showNoResults="false" selectLabel="" deselectLabel="" @input="
                (data) => {
                  setUpdateSelect(data.id, 'contracts__delivery_end_id');
                }
              " v-model="selectValues.contracts__delivery_end_id" label="address"
              :options="selectOptions.contracts__delivery_end_id" :maxHeight="400">
            </BaseSelect>
          </div>
          <!-- КОММЕНТАРИЙ КОНЦА  -->
          <div class="wp-100">
            <div class="fsc-11">{{ dataLang["reg_contract_edit_49"] }}</div>
            <BaseInputNew :disabled="!dataForModal.contracts__is_editable" placeholder="" width="210"
              input-name="contracts__delivery_end_comments" @input="updateInputAndCheckboxValue"
              :value="dataForModal.contracts__delivery_end_comments" :additionalParams="{}" name-sign="">
            </BaseInputNew>
          </div>
        </div>
        <div v-if="dataForModal.contracts__is_object_out" style="padding: 2px 0; background-color: #23b14d"
          class="fsc-12 fw-medium text-center text-white">
          {{ dataLang["reg_contract_edit_65"] }}
        </div>
        <!-- ОДОМЕТР И ТОПЛИВО ЗАВЕРШЕНИЯ -->
        <div class="contracts-modal-block__body" v-if="dataForModal.contracts__is_object_out" style="padding: 6px">
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <div class="d-flex gap-5 align-items-center" ref="contracts__odometr_end">
                <div style="display: flex; gap: 5px; align-items: center">
                  <div class="fsc-11">
                    {{ dataLang["reg_contract_edit_53"] }}
                  </div>
                </div>
                <BaseInputNew :class="{
                  'flag-block': !dataForModal.contracts__is_object_in,
                }" :disabled="!dataForModal.contracts__is_editable" placeholder="" width="50"
                  inputClass="text-center px-0" input-name="contracts__odometr_end" @input="updateInputAndCheckboxValue"
                  :value="dataForModal.contracts__odometr_end" :additionalParams="{}" name-sign="">
                </BaseInputNew>
              </div>
              <!-- КНОПКА ОБНОВЛЕНИЯ ОДОМЕТРА  -->
              <div @click="updateOdometrEnd" :style="{
                backgroundColor: computedDateOdometr ? '#FF3A20' : '#CACACA',
              }" style="
                  width: 26px;
                  height: 26px;
                  cursor: pointer;
                  display: flex;
                ">
                <img :src="require(`@/assets/icons/reload.svg`)" style="margin: auto" width="14" height="14" />
              </div>
            </div>
            <div class="d-flex gap-5 align-items-center" v-if="dataForModal.contracts__is_revert_confirmed_client"
              ref="contracts__fuel_end_liter">
              <div style="display: flex; gap: 5px; align-items: center">
                <div class="fsc-11">{{ dataLang["reg_contract_edit_54"] }}</div>
              </div>
              <BaseInputNew :class="{ 'flag-block': !dataForModal.contracts__is_object_in }"
                :disabled="!dataForModal.contracts__is_editable" placeholder="" width="29" inputClass="text-center"
                input-name="contracts__fuel_end_liter" @input="updateInputAndCheckboxValue"
                :value="dataForModal.contracts__fuel_end_liter" :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
          </div>
          <div class="fsc-9 text-muted">
            {{ dataLang["reg_contract_edit_66"] }}
            {{
              $time(dataForModal.contracts__odometr_end_updated_at).format(
                "HH:mm DD.MM.YYYY"
              )
            }}
            {{ dataLang["reg_contract_edit_67"] }}: {{ computedNumDiffOdometr }}
          </div>
        </div>
        <div v-if="dataForModal.contracts__is_revert_confirmed_client" style="padding: 2px 0; background-color: #23b14d"
          class="fsc-12 fw-medium text-center text-white">
          {{ dataLang["reg_contract_edit_68"] }}
        </div>

        <div v-if="dataForModal.contracts__is_revert_confirmed_client" class="contracts-modal-block__body"
          style="padding: 9px 10px">
          <!-- Грязное при выдаче  -->
          <div class="d-flex gap-5" style="margin-bottom: 9px">
            <!-- Элементы кузова  -->
            <div class="d-flex flex-column" style="gap: 4px">
              <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable" v-if="washData?.washing_type_body"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__end_state"
                v-model="washData.washing_type_body.contract_washings__end_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_body,
                        'end',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_body.washing_types__name]
                }}</span>
              </BaseCheckboxV2>
              <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable" v-if="washData?.washing_type_carpets"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__end_state"
                v-model="washData.washing_type_carpets.contract_washings__end_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_carpets,
                        'end',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_carpets.washing_types__name]
                }}</span>
              </BaseCheckboxV2>

              <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable" v-if="washData?.washing_type_salon"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__end_state"
                v-model="washData.washing_type_salon.contract_washings__end_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_salon,
                        'end',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_salon.washing_types__name]
                }}</span>
              </BaseCheckboxV2>

              <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable" v-if="washData?.washing_type_trunk"
                placeholder="" style="gap: 3px" class="" boxClass="bg-white" input-name="contract_washings__end_state"
                v-model="washData.washing_type_trunk.contract_washings__end_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_trunk,
                        'end',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[washData.washing_type_trunk.washing_types__name]
                }}</span>
              </BaseCheckboxV2>
            </div>
            <!-- Данные химчистки  -->
            <div class="d-flex flex-column" style="gap: 4px">
              <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable" placeholder="" class=""
                boxClass="bg-white" input-name="end" v-model="washAllSelect.end" style="gap: 3px"
                @oncheckeds="(data) => selectAllWashType(data, 'end')">
                <span class="text-dark">{{
                  dataLang["reg_contract_edit_60"]
                }}</span>
              </BaseCheckboxV2>
              <div class="d-flex">
                <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable"
                  v-if="washData?.washing_type_dryclean_seats" placeholder="" class="" boxClass="bg-white"
                  style="gap: 3px" input-name="contract_washings__end_state" v-model="washData.washing_type_dryclean_seats
                    .contract_washings__end_state
                    " @oncheckeds="
                      (data) =>
                        updateWashData(
                          washData.washing_type_dryclean_seats,
                          'end',
                          data.value
                        )
                    ">
                  <span class="text-dark">{{
                    dataLang[
                    washData.washing_type_dryclean_seats.washing_types__name
                    ]
                    }}</span>
                </BaseCheckboxV2>
                &nbsp;
                <BaseSelect :disabled="!dataForModal.contracts__is_editable"
                  v-if="washData?.washing_type_dryclean_seats" style="width: 36px" placeholder="" :showNoOptions="false"
                  :showNoResults="false" selectLabel="" deselectLabel="" @input="
                    (data) => {
                      updateWashData(
                        washData.washing_type_dryclean_seats,
                        'end',
                        data.value,
                        true
                      );
                    }
                  " v-model="washData.washing_type_dryclean_seats
                    .contract_washings__end_count
                    " label="label" :options="listCountSeatsForSelect" :maxHeight="150">
                </BaseSelect>
              </div>
              <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable"
                v-if="washData?.washing_type_dryclean_ceiling" placeholder="" class="" boxClass="bg-white"
                style="gap: 3px" input-name="contract_washings__end_state" v-model="washData.washing_type_dryclean_ceiling
                  .contract_washings__end_state
                  " @oncheckeds="
                    (data) =>
                      updateWashData(
                        washData.washing_type_dryclean_ceiling,
                        'end',
                        data.value
                      )
                  ">
                <span class="text-dark">{{
                  dataLang[
                  washData.washing_type_dryclean_ceiling.washing_types__name
                  ]
                  }}</span>
              </BaseCheckboxV2>
              <div class="d-flex justify-content-between">
                <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable"
                  v-if="washData?.washing_type_dryclean_floor" placeholder="" class="" boxClass="bg-white"
                  style="gap: 3px" input-name="contract_washings__end_state" v-model="washData.washing_type_dryclean_floor
                    .contract_washings__end_state
                    " @oncheckeds="
                      (data) =>
                        updateWashData(
                          washData.washing_type_dryclean_floor,
                          'end',
                          data.value
                        )
                    ">
                  <span class="text-dark">{{
                    dataLang[
                    washData.washing_type_dryclean_floor.washing_types__name
                    ]
                    }}</span>
                </BaseCheckboxV2>
                &nbsp;
                <BaseCheckboxV2 :disabled="!dataForModal.contracts__is_editable" placeholder="" class=""
                  boxClass="bg-white" style="gap: 3px" input-name="contracts__is_damage"
                  v-model="dataForModal.contracts__is_damage" @oncheckeds="(data) => updateDamageState(data.value)">
                  <span class="text-dark">{{
                    dataLang["reg_contract_edit_69"]
                  }}</span>
                </BaseCheckboxV2>
              </div>
            </div>
          </div>
          <div class="fsc-12 fw-bolder base-button wp-100" @click="
            $modal.show('confirmedIssueCarReturn', {
              contracts__id: contractId,
              additionalDate: calculateInputDate(
                dataForModal.contracts__ends,
                'send'
              ),
            })
            " style="padding: 5px 0" v-if="!dataForModal.contracts__is_object_in">
            {{ dataLang["reg_contract_edit_70"] }}
          </div>
          <div class="fsc-12 fw-bolder text-center text-muted wp-100" style="padding: 5px 0"
            v-if="dataForModal.contracts__is_object_in">
            {{ dataLang["reg_contract_edit_70"] }}
          </div>
        </div>
      </div>
      <!-- КОММЕНТАРИИ  -->
      <div class="contracts-modal-block contracts-modal-block--comments" style="min-width: 223px; max-width: 223px">
        <div class="contracts-modal-block__header">
          {{ dataLang["reg_contract_edit_50"] }}
        </div>
        <div class="contracts-modal-block__body">
          <div class="d-flex gap-5 mb-15">
            <BaseInputNew placeholder="" width="100%" class="wp-100" input-name="newComment"
              @input="(data) => (newCommentValue = data)" :horizontalTitle="true" ref="commentInput" value=""
              :additionalParams="{}" name-sign="">
            </BaseInputNew>
            <div class="base-button base-button--action px-5 py-5" style="min-height: 26px; height: 26px"
              @click="sendComment">
              <img :src="require(`@/assets/icons/add.svg`)" width="12" height="12" />
            </div>
          </div>
          <BaseScrollbar style="max-height: 472px">
            <div class="comments">
              <div class="comments-base d-flex flex-column gap-10">
                <div v-for="(comment, index) of commentsList" :key="comment.contract_comments__id"
                  class="comment d-flex gap-5 justify-content-between border border-1 border-disabled">
                  <div class="comment-info d-flex flex-column gap-0">
                    <p class="comment-info__heading text-black fw-normal fsc-11 lh-sm m-0">
                      {{
                        $time(comment.contract_comments__created_at)
                          .utc(true)
                          .utcOffset(Number(userSetting.company__utc))
                          .format(`${userSetting.company__tempalte_date} HH:mm`)
                      }}
                      {{ comment.employees__name }}
                    </p>
                    <p class="comment-info__content text-black fw-medium fsc-12 lh-sm m-0">
                      {{ comment.contract_comments__comment }}
                    </p>
                  </div>

                  <div class="comment-actions d-flex h-100">
                    <div :class="[
                      comment.contract_comments__is_fixed
                        ? 'comment-actions__pin--active'
                        : '',
                    ]"
                      class="comment-actions__pin d-flex justify-content-center align-items-center rounded-5 cursor-pointer"
                      @click="
                        () => {
                          fixComment(
                            comment.contract_comments__id,
                            !comment.contract_comments__is_fixed
                          );
                          comment.contract_comments__is_fixed =
                            !comment.contract_comments__is_fixed;
                        }
                      ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M13.1206 4.24668C13.2769 4.40289 13.2769 4.65616 13.1206 4.81236L12.727 5.20601C12.5708 5.36222 12.3175 5.36222 12.1613 5.20601L10.7942 3.83889C10.638 3.68268 10.638 3.42942 10.7942 3.27321L11.1878 2.87956C11.344 2.72335 11.5973 2.72335 11.7535 2.87956L13.1206 4.24668ZM13.4506 5.42578C13.6849 5.19119 14.065 5.19106 14.2994 5.42548L14.5476 5.67366C14.7066 5.8326 14.7066 6.09031 14.5476 6.24926L12.2452 8.55166C12.0863 8.71061 11.8286 8.71061 11.6696 8.55166L11.094 7.97606C11.041 7.92307 10.9551 7.92307 10.9021 7.97606L10.6567 8.2215C10.5741 8.30409 10.5536 8.43025 10.6059 8.53472L11.3466 10.0161C11.4249 10.1728 11.3942 10.362 11.2703 10.4859L9.36721 12.389C9.20827 12.5479 8.95056 12.5479 8.79161 12.389L6.68108 10.2785L2.41204 14.5475C2.25309 14.7064 1.99539 14.7064 1.83644 14.5475L1.45271 14.1638C1.29376 14.0048 1.29376 13.7471 1.45271 13.5882L5.72174 9.31913L3.61121 7.20859C3.45226 7.04964 3.45226 6.79194 3.61121 6.63299L5.51431 4.72989C5.63819 4.60601 5.82744 4.5753 5.98413 4.65365L7.46549 5.39433C7.56995 5.44656 7.69612 5.42608 7.7787 5.3435L8.02415 5.09805C8.07713 5.04507 8.07713 4.95917 8.02415 4.90619L7.44855 4.33059C7.2896 4.17164 7.2896 3.91393 7.44855 3.75499L9.75095 1.45258C9.9099 1.29364 10.1676 1.29364 10.3265 1.45258L10.5747 1.70076C10.8091 1.93518 10.809 2.31531 10.5744 2.54958L9.27128 3.85092C9.16532 3.95689 9.16532 4.12869 9.27128 4.23465L9.84688 4.81025C9.95285 4.91622 9.95285 5.08802 9.84688 5.19399L7.83228 7.20859C7.72631 7.31456 7.55451 7.31456 7.44855 7.20859L6.86789 6.62794C6.84727 6.60731 6.82346 6.59015 6.79737 6.57711L6.16455 6.2607C6.06009 6.20847 5.93392 6.22894 5.85134 6.31153L5.43394 6.72892C5.32798 6.83489 5.32798 7.00669 5.43394 7.11266L8.88755 10.5663C8.99351 10.6722 9.16532 10.6722 9.27128 10.5663L9.68868 10.1489C9.77126 10.0663 9.79174 9.94011 9.7395 9.83565L9.42309 9.20283C9.41005 9.17675 9.39289 9.15293 9.37227 9.13231L8.79161 8.55166C8.68565 8.44569 8.68565 8.27389 8.79161 8.16792L10.8062 6.15332C10.9122 6.04736 11.084 6.04736 11.1899 6.15332L11.7655 6.72892C11.8715 6.83489 12.0433 6.83489 12.1493 6.72892L13.4506 5.42578Z"
                          :fill="[
                            comment.contract_comments__is_fixed
                              ? 'white'
                              : '#31303D',
                          ]" />
                      </svg>
                    </div>
                    <div class="comment-actions__delete d-flex justify-content-center align-items-center cursor-pointer"
                      @click="delComment(comment.contract_comments__id)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M2.66983 1.70071C2.40222 1.4331 1.96833 1.4331 1.70071 1.70071C1.4331 1.96833 1.4331 2.40222 1.70071 2.66983L7.03088 8L1.70071 13.3302C1.4331 13.5978 1.4331 14.0317 1.70071 14.2993C1.96833 14.5669 2.40222 14.5669 2.66983 14.2993L8 8.96912L13.3301 14.2992C13.5977 14.5668 14.0316 14.5668 14.2992 14.2992C14.5668 14.0316 14.5668 13.5977 14.2992 13.3301L8.96912 8L14.2993 2.66983C14.5669 2.40222 14.5669 1.96833 14.2993 1.70071C14.0317 1.4331 13.5978 1.4331 13.3302 1.70071L8 7.03088L2.66983 1.70071Z"
                          fill="black" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BaseScrollbar>
        </div>
      </div>
    </div>
    <!-- ТАБ РАСЧЕТ -->
    <div v-if="activateTab == dataLang['reg_contract_edit_72']">
      <div style="padding: 15px 27px 0px 27px">
        <div style="height: 495px">
          <ve-table :border-around="false" style="overflow-y: auto" fixed-header :max-height="495" :columns="columns"
            :table-data="dataTable" :border-x="true" :border-y="true" row-key-field-name="contract_calculations__id"
            ref="mainTable" v-if="!localLoading" :checkbox-option="{
              hideSelectAll: false,
            }" :clickHighlight="false" :cell-style-option="{}" :rowStyleOption="{
              hoverHighlight: true,
            }" :cellSelectionOption="{ enable: false }">
          </ve-table>
        </div>

        <div class="d-flex fsc-12 fw-bold mb-10" style="gap: 1px">
          <div class="wp-85 bg-disabled" style="padding: 6.5px 10px">
            {{ dataLang["reg_contract_edit_77"] }}
          </div>
          <div class="wp-15 bg-disabled text-center" style="padding: 6.5px 10px">
            {{ resultSumFromTable }}
          </div>
        </div>
        <div class="p-10 fsc-11">{{ dataLang["reg_contract_edit_78"] }}</div>
      </div>
    </div>

    <!-- КНОПКИ СОХРАНЕНИЯ -->
    <div class="d-flex align-items-center gap-35" style="padding: 0 27px">
      <div class="flex-grow-1 d-flex">
        <div class="flex-grow-1 bg-danger text-white d-flex gap-5 align-items-center px-15 fsc-12 fw-normal"
          style="height: 36px" v-if="BLAlert" v-html="BLAlert"></div>
      </div>
      <div class="d-flex justify-content-end gap-30">
        <div class="base-button text-uppercase" @click="$modal.hide('contractsModal')">
          Отменить
        </div>
        <div class="base-button text-uppercase" @click="saveModal(false, true)">
          Сохранить и закрыть
        </div>
      </div>
    </div>
    <ConfirmedIssueAndRevertModal @update="saveModal(true, false)" @error="errorsHandler" />
    <ConfirmedIssueCarReturn @update="saveModal(false, true)" @error="errorsHandler" />
    <RegionsContractsModal @update="getRegionsChecklist" />
    <ManagerContractsModal @update="getTitle" />
  </BaseModal>
</template>

<script>
import ConfirmedIssueAndRevertModal from "./ConfirmedIssueAndRevertModal.vue";
import ConfirmedIssueCarReturn from "./ConfirmedIssueCarReturn.vue";
import RegionsContractsModal from "./RegionsContractsModal.vue";
import ManagerContractsModal from "./ManagerContractsModal.vue";
import GeneralService from "@/api/GeneralService";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import { VeTable } from "vue-easytable";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    ConfirmedIssueAndRevertModal,
    ConfirmedIssueCarReturn,
    RegionsContractsModal,
    ManagerContractsModal,
  },
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
    typeReestr: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      newCommentValue: null,
      commentsList: [],
      contractId: null,
      titleLine: null,
      dataTable: [],
      isHasErrorSave: false,
      blackListData: null,
      regionsListData: null,
      inputTimeout: null,
      resultSumFromTable: null,
      listCountSeatsForSelect: [],
      washData: {
        washing_type_dryclean_seats: {},
        washing_type_dryclean_ceiling: {},
        washing_type_dryclean_floor: {},
        washing_type_body: {},
        washing_type_carpets: {},
        washing_type_salon: {},
        washing_type_trunk: {},
      },
      dataForModal: {},
      washAllSelect: {
        start: false,
        end: false,
      },
      washingList: {},
      selectOptions: {
        drivers: [],
        contracts__vehicle_id: [],
        contracts__count_seats_child: [],
        contracts__city_start_id: [],
        contracts__place_start_id: [],
        contracts__place_end_id: [],
        contracts__city_end_id: [],
        contracts__prolongation_type_id: [],
        contracts__delivery_start_id: [],
        contracts__delivery_end_id: [],
      },
      selectValues: {
        firstDriver: {},
        secondDriver: {},
        contracts__vehicle_id: {},
        contracts__count_seats_child: [],
        contracts__city_start_id: {},
        contracts__place_start_id: {},
        contracts__place_end_id: {},
        contracts__city_end_id: {},
        contracts__prolongation_type_id: {},
        contracts__delivery_start_id: {},
        contracts__delivery_end_id: {},
      },
      activateTab: null,
      updatedValues: {},
      isUpdatedData: false,
      clientsOnBlacklist: false,
      localLoading: false,
      // ПОЛЯ КОТОРЫЕ ТРИГГЕРЯТ ИЗМЕНЕНИЯ БЕЗ СОХРАНЕНИЯ
      fieldListForUpdate: [
        "contracts__vehicle_id",
        "contracts__current_t_allowed_day_km",
        "contracts__starts",
        "contracts__ends",
        "contracts__tariff_from",
        "contracts__city_start_id",
        "contracts__place_start_id",
        "contracts__city_end_id",
        "contracts__place_end_id",
      ],
      // СПИСОК ПОЛЕЙ ДЛЯ ДАТ КАЛЕНДАРЕЙ ЧТОБЫ ТРАНСОФРМИРОВАТЬ ПОД ФОРМАТ ЧТОБЫ ИНПУТ ПОКАЗЫВАЛ
      dateFieldListForTransform: [
        "contracts__extendtariff_date",
        "contracts__tariff_from",
        "contracts__starts",
        "contracts__ends",
        "contracts__prolongation_date",
      ],
    };
  },
  methods: {
    updateRadioInsuranse(data) {
      if (data.name == "contracts__current_t_is_fr") {
        this.dataForModal.contracts__current_t_is_fr = 1;
        this.updateValue({ name: "contracts__current_t_is_fr", value: 1 });
        this.dataForModal.contracts__current_t_is_fr_day = 0;
        this.updateValue({ name: "contracts__current_t_is_fr_day", value: 0 });
      } else {
        this.dataForModal.contracts__current_t_is_fr = 0;
        this.updateValue({ name: "contracts__current_t_is_fr", value: 0 });
        this.dataForModal.contracts__current_t_is_fr_day = 1;
        this.updateValue({ name: "contracts__current_t_is_fr_day", value: 1 });
      }
    },

    async loadDoc(name, type) {
      let API_PATH = "";
      switch (process.env.VUE_APP_MODE_BUILD) {
        case "production":
          API_PATH = `crmrent`;
          break;
        case "testing":
          API_PATH = `crmtest`;
          break;
        case "development":
          API_PATH = `sirius.development`;
          break;
        case "serve-hmr":
          API_PATH = `sirius.development`;
          break;
      }
      try {
        this.localLoading = true;
        let dataFrom = await axios.get(
          `https://converter.${API_PATH}.ru/${type}`,
          {
            responseType: "blob",
            headers: {
              "X-Employee-Token": JSON.parse(
                localStorage.getItem("user-token")
              ),
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        const url = window.URL.createObjectURL(dataFrom.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${name} от ${this.$time().format("DD.MM.YYYY")}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        console.error(error);
      } finally {
        this.localLoading = false;
      }
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeStart(date) {
      if (this.dataForModal.contracts__starts) {
        return (
          date <=
          this.$time(
            this.calculateInputDate(
              this.dataForModal.contracts__starts,
              "send"
            ).slice(0, -3)
          ).subtract(1, "day")
        );
      }
    },
    notBeforeSpecificDate(date) {
      if (this.dataForModal.contracts__ends) {
        return (
          date <=
          this.$time(
            this.calculateInputDate(
              this.dataForModal.contracts__ends,
              "send"
            ).slice(0, -3)
          ).subtract(1, "day")
        );
      }
    },
    notAfterDateStart(date) {
      if (this.dataForModal.contracts__starts) {
        return (
          date >
          this.$time(
            this.calculateInputDate(
              this.dataForModal.contracts__starts,
              "send"
            ).slice(0, -3)
          )
        );
      }
    },
    beforeCloseModal() {
      if (this.$route.path !== "/contracts") {
        this.$router.push({ path: "/contracts", query: {} });
      }
      this.$emit("updateDataTable");
    },

    /**
     * Которая перебирает все ключи с копейками и удаляет их
     */
    removePenniesFromKeys() {
      let listKeysForReplace = [
        "contracts__rerun_km",
        "contracts__current_t_allowed_day_km",
        "contracts__current_t_child_seat_cost",
        "contracts__current_t_cost",
        "contracts__current_t_deposit_cost",
        "contracts__current_t_fr_cost",
        "contracts__current_t_fr_day_cost",
        "contracts__current_t_one_km_cost",
        "contracts__current_t_pledge_cost",
      ];
      listKeysForReplace.forEach((key, index) => {
        if (String(this.dataForModal[key]).includes(".")) {
          this.dataForModal[key] = this.dataForModal[key].split(".")[0];
        }
      });
    },

    calculateInputDate(date, type) {
      if (type == "send") {
        return (
          date.split(" ")[0].split(".").reverse().join("-") +
          " " +
          date.split(" ")[1] +
          ":00"
        );
      } else {
        return (
          date.split(" ")[0].split("-").reverse().join(".") +
          " " +
          date.split(" ")[1]
        );
      }
    },
    async loadComments() {
      return GeneralService.get(`/contracts/${this.contractId}/comments`)
        .then((data) => {
          this.commentsList = data.data.data.rows.sort(
            (a, b) =>
              b.contract_comments__is_fixed - a.contract_comments__is_fixed
          );
        })
        .catch((e) => { });
    },
    delComment(id) {
      GeneralService.delete(`/contracts/${this.contractId}/comments/${id}`)
        .then(async (data) => {
          this.$toast.success(data.data.message);
          await this.loadComments();
        })
        .catch((e) => { });
    },
    fixComment(id, fix) {
      GeneralService.edit(`/contracts/${this.contractId}/comments/${id}`, {
        contract_comments__is_fixed: fix,
      })
        .then(async (data) => {
          this.$toast.success(data.data.message);
          await this.loadComments();
          this.newCommentValue = null;
        })
        .catch((e) => { });
    },
    sendComment() {
      if (this.newCommentValue?.value) {
        GeneralService.editOrCreate(`/contracts/${this.contractId}/comments`, {
          contract_comments__comment: this.newCommentValue.value,
        })
          .then(async (data) => {
            // this.selects.push(data.data.data.rows)
            this.$toast.success(data.data.message);
            await this.loadComments();
            this.newCommentValue = null;
            this.$refs.commentInput.$el.querySelector("input").value = "";
          })
          .catch((e) => { });
      } else {
        this.$toast.error("Напишите комментарий", { duration: 5000 });
      }
    },
    /**
     * Функция отмечающая все чекбоксы сразу в зависимости от типа start/end
     */
    selectAllWashType(data, type) {
      this.washData.washing_type_dryclean_seats[
        `contract_washings__${type}_state`
      ] = Boolean(data.value);
      this.washData.washing_type_dryclean_ceiling[
        `contract_washings__${type}_state`
      ] = Boolean(data.value);
      this.washData.washing_type_dryclean_floor[
        `contract_washings__${type}_state`
      ] = Boolean(data.value);
      this.localLoading = true;

      if (type == "start" && Boolean(data.value)) {
        this.washData.washing_type_dryclean_seats.contract_washings__start_count =
          this.listCountSeatsForSelect.find((x) => x.value == 4);
      } else if (type == "end" && Boolean(data.value)) {
        this.washData.washing_type_dryclean_seats.contract_washings__end_count =
          this.listCountSeatsForSelect.find((x) => x.value == 4);
      }

      Promise.all([
        this.updateWashData(
          this.washData.washing_type_dryclean_seats,
          type,
          data.value
        ),
        this.updateWashData(
          this.washData.washing_type_dryclean_ceiling,
          type,
          data.value
        ),
        this.updateWashData(
          this.washData.washing_type_dryclean_floor,
          type,
          data.value
        ),
        Boolean(data.value)
          ? this.updateWashData(
            this.washData.washing_type_dryclean_seats,
            type,
            4,
            true
          )
          : "",
      ])
        .then(() => {
          this.$toast.success("");
        })
        .finally(() => {
          this.localLoading = false;
        });
    },
    async updateOdometrEnd() {
      return GeneralService.editOrCreate(
        `/contracts/${this.contractId}/odometr`,
        {
          odometr: !this.updatedValues?.contracts__odometr_end
            ? this.dataForModal.contracts__odometr_end
            : this.updatedValues?.contracts__odometr_end,
        }
      )
        .then((data) => {
          this.$toast.success(data.data.message);
          if (this.updatedValues.contracts__odometr_end) {
            this.dataForModal.contracts__odometr_end =
              this.updatedValues.contracts__odometr_end;
          }
          this.dataForModal.contracts__odometr_end_updated_at = this.$time();
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR UPDATE ODOMETR", { duration: 5000 });
          }
        });
    },
    async updateDamageState(dataUpdate) {
      return GeneralService.edit(`/contracts/${this.contractId}/damage`, {
        contracts__is_damage: dataUpdate,
      })
        .then((data) => {
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR UPDATE DAMAGE", { duration: 5000 });
          }
        });
    },
    async updateWashData(dataUpdate, type, value, isCount) {
      return GeneralService.edit(
        `/contracts/${this.contractId}/washings/${dataUpdate.contract_washings__id}`,
        isCount
          ? { [`contract_washings__${type}_count`]: value }
          : { [`contract_washings__${type}_state`]: value }
      )
        .then((data) => { })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR UPDATE WASHINGS", { duration: 5000 });
          }
        });
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      // if (data.name !== 'contracts__address') {
      //   this.isUpdatedData = true
      // }
      this.isUpdatedData = true;
      console.log("UPDATE DATA", this.updatedValues);
    },
    errorsHandler(errors) {
      Object.keys(errors).forEach((elem, index) => {
        if (this.$refs[elem]) {
          this.$refs[elem].classList.add("input-error");
        }
      });
    },
    async saveModal(isLoadGlobalData, isClose) {
      this.localLoading = true;
      this.isUpdatedData = false;
      this.isHasErrorSave = false
      if (this.contractId) {
        return GeneralService.edit(`/contracts/${this.contractId}`, {
          ...this.updatedValues,
        })
          .then(async () => {
            this.updatedValues = {};
            if (isLoadGlobalData) {
              await this.loadData();
            } else {
              this.localLoading = false;
              if (isClose) {
                this.$modal.hide("contractsModal");
              }
            }
          })
          .catch((e) => {
            console.error(e);
            if (e?.response?.data) {
              Object.keys(e.response.data.errors).forEach((elem, index) => {
                this.isHasErrorSave = true
                if (this.$refs[elem]) {
                  this.$refs[elem].classList.add("input-error");
                }
              });
              this.$toast.error(e?.response.data.message, { duration: 5000 });
            } else {
              this.$toast.error("ERROR SAVE CONTRACT", { duration: 5000 });
            }
            this.localLoading = false;
          });
      } else {
        if (isClose) {
          this.$modal.hide("contractsModal");
        } else {
          if (isLoadGlobalData) {
            await this.loadData();
          }
        }
      }
    },
    /**
     * Функция которая возвращает данные для обработчика changed
     */
    getFeieldForUpdatedList(fieldName) {
      return {
        contracts__starts: this.updatedValues?.["contracts__starts"]
          ? this.updatedValues["contracts__starts"]
          : this.calculateInputDate(
            this.dataForModal.contracts__starts.slice(0, -3),
            "send"
          ),
        contracts__ends: this.updatedValues?.["contracts__ends"]
          ? this.updatedValues["contracts__ends"]
          : this.calculateInputDate(
            this.dataForModal.contracts__ends.slice(0, -3),
            "send"
          ),
        contracts__predicted_run: this.updatedValues?.[
          "contracts__predicted_run"
        ]
          ? this.updatedValues["contracts__predicted_run"]
          : this.dataForModal.contracts__predicted_run,
        contracts__tariff_from: this.updatedValues?.["contracts__tariff_from"]
          ? this.updatedValues["contracts__tariff_from"]
          : this.calculateInputDate(
            this.dataForModal.contracts__tariff_from.slice(0, -3),
            "send"
          ),
        contracts__vehicle_id:
          this.selectValues.contracts__vehicle_id.vehicles__id,
        contracts__city_start_id:
          this.selectValues.contracts__city_start_id.cities__id,
        contracts__place_start_id:
          this.selectValues.contracts__place_start_id.id,
        contracts__city_end_id:
          this.selectValues.contracts__city_end_id.cities__id,
        contracts__place_end_id: this.selectValues.contracts__place_end_id.id,
      };
    },

    /// ЗАПРОС ДЛЯ ОБНОВЛЕНИЯ ДАННЫХ БЕЗ СОХРАНЕНИЯ
    getUpdatedChangeData(payload) {
      this.localLoading = true;
      GeneralService.editOrCreate(
        `/contracts/${this.contractId}/changed/${payload.name}`,
        this.getFeieldForUpdatedList(payload.name)
      )
        .then(async (data) => {
          console.log("CHANGE DATA ||||", data);

          let unrowData = data.data.data;

          this.$toast.success(data.data.message);
          this.dataForModal = Object.assign(this.dataForModal, unrowData);

          this.transformDateFromList();
          this.removePenniesFromKeys();
          /**
           * Тут берем данные после промежуточного сохранения,
           * вставляем их в объект updatedValues чтобы отправить на полноценное сохранение
           * В ответе могут быть как обычные ключи, так и объекты
           */
          Object.keys(unrowData).forEach((key) => {
            if (unrowData[key] instanceof Object) {
              this.updatedValues[key] = unrowData[key].id;
            } else {
              this.updatedValues[key] = unrowData[key];
            }
          });

          if (unrowData?.contractDuration) {
            this.dataForModal.contracts__duration = unrowData?.contractDuration;
          }

          /**
           * Берем данные которые пришли в обработчик и по ключу изменившегося поля
           * пытаемся сделать запрос
           */

          if (payload.name == "contracts__city_start_id") {
            await this.getPlacesList(payload.value, "start");
          }
          if (payload.name == "contracts__city_end_id") {
            await this.getPlacesList(payload.value, "end");
          }
          if (payload.name == "contracts__place_start_id") {
            await this.getDeliveryList(payload.value, "start");
          }
          if (payload.name == "contracts__place_end_id") {
            await this.getDeliveryList(payload.value, "end");
          }

          /// ЗАПОЛНЕНИЕ ГОРОДА НАЧАЛА И ЗАВЕРШЕНИЯ
          if (unrowData?.["contracts__city_start_id"]) {
            this.selectValues.contracts__city_start_id = {
              contracts__city_start_id:
                unrowData["contracts__city_start_id"].id,
              cities__name: unrowData["contracts__city_start_id"].value,
            };
          }
          if (unrowData?.["contracts__city_end_id"]) {
            this.selectValues.contracts__city_end_id = {
              contracts__city_end_id: unrowData["contracts__city_end_id"].id,
              cities__name: unrowData["contracts__city_end_id"].value,
            };
          }

          if (unrowData?.["contracts__place_start_id"]) {
            this.selectValues.contracts__place_start_id = {
              id: unrowData["contracts__place_start_id"].id,
              address: unrowData["contracts__place_start_id"].value,
            };
          }
          if (unrowData?.["contracts__place_end_id"]) {
            this.selectValues.contracts__place_end_id = {
              id: unrowData["contracts__place_end_id"].id,
              address: unrowData["contracts__place_end_id"].value,
            };
          }

          if (unrowData?.["contracts__delivery_start_id"]) {
            this.selectValues.contracts__delivery_start_id =
              this.selectOptions.contracts__delivery_start_id.find(
                (item) =>
                  item.id == unrowData["contracts__delivery_start_id"].id
              );
          }
          if (unrowData?.["contracts__delivery_end_id"]) {
            this.selectValues.contracts__delivery_end_id =
              this.selectOptions.contracts__delivery_end_id.find(
                (item) => item.id == unrowData["contracts__delivery_end_id"].id
              );
          }
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR CHANGE UPDATE", { duration: 5000 });
          }
        })
        .finally(() => {
          this.localLoading = false;
        });
    },

    searchFieldForUpdate(fieldName) {
      return !!this.fieldListForUpdate.find((name) => name == fieldName);
    },
    /// ОБРАБОТЧИК СОХРАНЕНИЯ СЕЛЕКТА
    async setUpdateSelect(value, name) {
      this.updateValue({ name: name, value: value });
      if (this.searchFieldForUpdate(name)) {
        this.getUpdatedChangeData({ name: name, value: value });
      }
    },
    /// ОБРАБОТЧИК СОХРАНЕНИЯ ЛЮБОГО ИНПУТА
    updateInputAndCheckboxValue(data) {
      this.updateValue({ name: data.name, value: data.value });

      /// КОГДА ОБНОВЛЯЕМ ДАТУ КОНЦА АРЕНДЫ - НУЖНО ТАК ЖЕ ОБНОВИТЬ СТАТУС ПРОДЛЕНИЯ
      if (data.name == "contracts__ends") {
        this.updateValue({ name: "contracts__prolongation_type_id", value: 2 });
        this.selectValues.contracts__prolongation_type_id =
          this.selectOptions.contracts__prolongation_type_id.find(
            (polon) => polon.contract_prolongations_types__id == 2
          );
      }
      clearTimeout(this.inputTimeout);
      this.inputTimeout = setTimeout(() => {
        if (this.searchFieldForUpdate(data.name)) {
          this.getUpdatedChangeData(data);
        }
      }, 1500);
    },
    /// ОБРАБОТЧИК ПЕРЕХОДА ПО ВКЛАДКАМ
    async handleTabChange(newTab) {
      console.log(newTab, "TABS CHANGE CONSOLE", this.activateTab);
      if (newTab !== this.dataLang["reg_contract_edit_71"]) {
        try {
          await this.saveModal()
          if (!this.isHasErrorSave) {
            this.activateTab = newTab;
            await this.getTable();
          }
        } catch (e) {
          console.log(e);
        }

      } else {
        this.activateTab = newTab;
        await this.loadData();
      }
    },
    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    async getTable() {
      this.resultSumFromTable = 0;
      this.localLoading = true;
      return GeneralService.get(`/contracts/${this.contractId}/tab2`)
        .then((data) => {
          this.dataTable = data.data.data;
          this.dataTable.forEach((item) => {
            this.resultSumFromTable =
              this.resultSumFromTable +
              Number(item.contract_calculations__total);
            item.contract_calculations__total =
              String(item.contract_calculations__total).split(".")[0] +
              "," +
              String(item.contract_calculations__total).split(".")[1];
            item.contract_calculations__cost =
              item.contract_calculations__cost.split(".")[0];
          });
          this.resultSumFromTable = this.resultSumFromTable.toFixed(2);
          this.resultSumFromTable =
            String(this.resultSumFromTable).split(".")[0] +
            "," +
            String(this.resultSumFromTable).split(".")[1];
        })
        .catch((e) => {
          console.error(e);
          if (e?.response?.data) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET TABLE", { duration: 5000 });
          }
        })
        .finally(() => {
          this.localLoading = false;
        });
    },

    async getTitle() {
      return GeneralService.get(`/contracts/${this.contractId}/title`)
        .then((data) => {
          this.titleLine = data.data.data;
        })
        .catch((e) => {
          console.error(e);
          if (e?.response?.data) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET BLACKLIST", { duration: 5000 });
          }
        });
    },
    /**
     * Запрос для получения статуса клиента: в черном списке или нет
     */
    async getСheckIsBlacklist() {
      return GeneralService.get(
        `/clients/${this.dataForModal.contracts__client_id}/check_blacklist`
      )
        .then((data) => {
          this.blackListData = data.data.data;
        })
        .catch((e) => {
          console.error(e);
          if (e?.response?.data) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET BLACKLIST", { duration: 5000 });
          }
        });
    },
    /**
     * Запрос для регионов объекта
     */
    async getRegionsChecklist() {
      if (this.$refs["contracts__regions"]) {
        this.$refs["contracts__regions"].classList.remove("input-error");
      }
      return GeneralService.get(`/contracts/${this.contractId}/regions`)
        .then((data) => {
          this.regionsListData = data.data.data.rows;
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET REGIONS", { duration: 5000 });
          }
        });
    },

    /**
     * Запрос для получения городов начала аренды
     */
    async getCitiesList(type) {
      return GeneralService.get(`/contracts/${this.contractId}/cities/${type}`)
        .then((data) => {
          if (type == "start") {
            this.selectOptions.contracts__city_start_id = data.data.data;
          } else {
            this.selectOptions.contracts__city_end_id = data.data.data;
          }
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET CITIES", { duration: 5000 });
          }
        });
    },
    /**
     * Запрос для получения площадок начала аренды
     */
    async getPlacesList(cityId, type) {
      return GeneralService.get(
        `/contracts/${this.contractId}/places/${type}/${cityId}`
      )
        .then((data) => {
          if (type == "start") {
            this.selectOptions.contracts__place_start_id = data.data.data;
          } else {
            this.selectOptions.contracts__place_end_id = data.data.data;
          }
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET PLACES", { duration: 5000 });
          }
        });
    },

    /**
     * Запрос для получения доставок начала аренды
     */
    async getDeliveryList(placeId, type) {
      return GeneralService.get(
        `/contracts/${this.contractId}/delivery/${placeId}`
      )
        .then((data) => {
          let resultForType =
            data.data.data instanceof Array ? data.data.data : [data.data.data];
          if (type == "start") {
            this.selectOptions.contracts__delivery_start_id = resultForType;
          } else {
            this.selectOptions.contracts__delivery_end_id = resultForType;
          }
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR DELIVERES PLACES", { duration: 5000 });
          }
        });
    },

    /**
     * Получить текущее состояние чистоты
     */
    async getWashList() {
      return GeneralService.get(`/contracts/${this.contractId}/washings`)
        .then((data) => {
          console.log("GET WASHINGS ||||", data);
          data.data.data.forEach((elem) => {
            this.washData[elem["washing_types__name"]] = elem;
          });

          /**
           * Определить чекбоксы полной химчистки
           */
          this.washAllSelect.start =
            this.washData.washing_type_dryclean_seats[
            `contract_washings__start_state`
            ] &&
            this.washData.washing_type_dryclean_ceiling[
            `contract_washings__start_state`
            ] &&
            this.washData.washing_type_dryclean_floor[
            `contract_washings__start_state`
            ];
          this.washAllSelect.end =
            this.washData.washing_type_dryclean_seats[
            `contract_washings__end_state`
            ] &&
            this.washData.washing_type_dryclean_ceiling[
            `contract_washings__end_state`
            ] &&
            this.washData.washing_type_dryclean_floor[
            `contract_washings__end_state`
            ];

          /**
           * Определить селекты для количества сидений химчистки
           */
          this.washData.washing_type_dryclean_seats.contract_washings__start_count =
            this.listCountSeatsForSelect.find((item) => {
              return (
                item.value ==
                this.washData.washing_type_dryclean_seats
                  .contract_washings__start_count
              );
            });
          this.washData.washing_type_dryclean_seats.contract_washings__end_count =
            this.listCountSeatsForSelect.find((item) => {
              return (
                item.value ==
                this.washData.washing_type_dryclean_seats
                  .contract_washings__end_count
              );
            });
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("ERROR GET WASHINGS", { duration: 5000 });
          }
        });
    },

    transformDateFromList() {
      this.dateFieldListForTransform.forEach((dataKey) => {
        if (this.dataForModal[dataKey]) {
          this.dataForModal[dataKey] = this.calculateInputDate(
            this.dataForModal[dataKey],
            "input"
          );
        }
      });
    },

    async loadData(dataFromPage) {
      this.activateTab = this.dataLang["reg_contract_edit_71"];

      this.localLoading = true;
      /**
       * Присвоение локальных данных по клику в записи таблицы
       */
      if (dataFromPage && dataFromPage?.params?.contracts__id) {
        console.log("DATA FROM TABLE", dataFromPage.params);
        this.contractId = dataFromPage.params.contracts__id;
      }

      return Promise.all([
        this.getCitiesList("start"),
        this.getCitiesList("end"),
        this.getRegionsChecklist(),
        this.getWashList(),
        this.getTitle(),
        this.loadComments(),
        GeneralService.get(`/contracts/prolongation/statuses`)
          .then((data) => {
            console.log("GET PROLONGATION STATUSES ||||", data);

            this.selectOptions.contracts__prolongation_type_id = data.data.data;
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error("ERROR GET PROLONGATION STATUSES", { duration: 5000 });
          }),
        GeneralService.get(`/contracts/${this.contractId}/objects`)
          .then((data) => {
            console.log("GET OBJECTS ||||", data);
            this.selectOptions.contracts__vehicle_id = data.data.data;
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error("ERROR GET OBJECTS", { duration: 5000 });
          }),
        GeneralService.get(`/contracts/${this.contractId}/clients`)
          .then((data) => {
            console.log("GET DRIVERS ||||", data);
            this.selectOptions.drivers = [
              {
                clients__name: "Не выбран",
                clients__id: null,
                clients__phone: "",
              },
              ...data.data.data.rows,
            ];
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error("ERROR GET DRIVERS", { duration: 5000 });
          }),
        GeneralService.get(`/contracts/${this.contractId}/tab1`)
          .then(async (data) => {
            console.log("GET TAB 1 ||||", data.data.data);

            this.dataForModal = data.data.data;

            this.transformDateFromList();
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error("ERROR GET TAB1", { duration: 5000 });
          }),
      ])
        .then(async () => {
          await Promise.all([
            // ПЕРВОНАЧАЛЬНЫЙ ЗАПРОС ЗА ПЛОЩАДКАМИ СТАРТА ИСПОЛЬЗУЯ ТЕКУЩИЙ ГОРОД
            this.getPlacesList(
              this.dataForModal.contracts__city_start_id,
              "start"
            ),
            // ПЕРВОНАЧАЛЬНЫЙ ЗАПРОС ЗА ПЛОЩАДКАМИ ЗАВЕРШЕНИЯ ТЕКУЩИЙ ГОРОД
            this.getPlacesList(this.dataForModal.contracts__city_end_id, "end"),
            // ДОСТАВКИ СТАРТА
            this.getDeliveryList(
              this.dataForModal.contracts__place_start_id,
              "start"
            ),
            // ДОСТАВКИ ЗАВЕРШЕНИЯ
            this.getDeliveryList(
              this.dataForModal.contracts__place_end_id,
              "end"
            ),
            // ЗАПРОС ЗА СТАТУСОМ КЛИЕНТА
            this.getСheckIsBlacklist(),
          ]);
        })
        .then((data) => {
          // РАСПРЕДЕЛНИЕ КЛЮЧЕЙ ПО СЕЛЕКТАМ

          // Первый и второй водитель селекта (Телефон, имя)
          this.selectValues.firstDriver = this.selectOptions.drivers.find(
            (driver) => {
              return (
                driver.clients__id ==
                this.dataForModal.contracts__client_driver1_id
              );
            }
          );
          this.selectValues.secondDriver = this.selectOptions.drivers.find(
            (driver) => {
              return (
                driver.clients__id ==
                this.dataForModal.contracts__client_driver2_id
              );
            }
          );
          if (!this.selectValues.firstDriver) {
            this.selectValues.firstDriver = this.selectOptions.drivers.find(
              (driver) => {
                return driver.clients__id == null;
              }
            );
          }
          if (!this.selectValues.secondDriver) {
            this.selectValues.secondDriver = this.selectOptions.drivers.find(
              (driver) => {
                return driver.clients__id == null;
              }
            );
          }
          ////

          // Поиск и назначение объекта для селекта (Исходя из данных, пришедших в заказе)
          this.selectValues.contracts__vehicle_id = {
            vehicles__name: this.dataForModal.vehicles__name,
            vehicles__id: this.dataForModal.vehicles__id,
            vehicles__gosnumber: this.dataForModal.vehicles__gosnumber,
          };
          ////

          /// ЗАПОЛНЕНИЕ СТАТИЧЕСКОГО ИНПУТА КОЛИЧЕСТВА ДЕТСКИХ СИДЕНИЙ
          this.selectValues.contracts__count_seats_child =
            this.selectOptions.contracts__count_seats_child.find(
              (currentCountObject) =>
                currentCountObject.label ==
                this.dataForModal.contracts__count_seats_child
            );
          ////

          /// ТРАНСОФРМАЦИЯ ДАТЫ ДЛЯ ЗАПИСИ ПОСЛЕДНЕГО ОБНРОВЛЕНИЯ ОДОМЕТРА ПОСЛЕ UTC
          this.dataForModal.contracts__odometr_end_updated_at = this.$time(
            this.dataForModal.contracts__odometr_end_updated_at
          )
            .utc(true)
            .utcOffset(Number(this.userSetting.company__utc));
          ////

          /// ЗАПОЛНЕНИЕ ГОРОДА НАЧАЛА И ЗАВЕРШЕНИЯ
          this.selectValues.contracts__city_start_id = {
            contracts__city_start_id:
              this.dataForModal.contracts__city_start_id,
            cities__name: this.dataForModal.cities_start__name,
          };
          this.selectValues.contracts__city_end_id = {
            contracts__city_end_id:
              this.dataForModal.contracts__city_end_id,
            cities__name: this.dataForModal.cities_end__name,
          };

          /// ЗАПОЛНЕНИЕ ПЛОЩАДКИ НАЧАЛА И ЗАВЕРШЕНИЯ
          this.selectValues.contracts__place_start_id = this.selectOptions.contracts__place_start_id[0];
          this.selectValues.contracts__place_end_id = this.selectOptions.contracts__place_end_id[0];
          ////

          /// ЗАПОЛНЕНИЕ ДОСТАВКИ НАЧАЛА И ЗАВЕРШЕНИЯ
          this.selectValues.contracts__delivery_start_id =
            this.selectOptions.contracts__delivery_start_id.find(
              (item) =>
                item.id == this.dataForModal.contracts__delivery_start_id
            );
          this.selectValues.contracts__delivery_end_id =
            this.selectOptions.contracts__delivery_end_id.find(
              (item) => item.id == this.dataForModal.contracts__delivery_end_id
            );
          ////

          /// ЗАПОЛНЕНИЕ ВАРИАНТОВ ПРОДЛЕНИЯ
          this.selectValues.contracts__prolongation_type_id =
            this.selectOptions.contracts__prolongation_type_id.find(
              (item) =>
                this.dataForModal.contracts__prolongation_type_id ==
                item.contract_prolongations_types__id
            );

          /// УДАЛЕНИЕ КОПЕЕК ИЗ КЛЮЧЕЙ
          this.removePenniesFromKeys();

          this.localLoading = false;
        });
    },
  },

  mounted() {
    this.contractId = null;
  },
  beforeUnmounted() {
    // EventBus.$off('saveUpdatedModalValue')
  },
  created() {
    // ЗАПОЛНЕНИЕ СТАТИЧЕСКОГО ИНПУТА ДЛЯ ДЕТСКИХ СИДЕНИЙ
    this.selectOptions.contracts__count_seats_child = [
      { label: 1 },
      { label: 2 },
      { label: 3 },
      { label: 4 },
    ];
    // ЗАПОЛНЕНИЕ СТАТИЧЕСКОГО ИНПУТА ДЛЯ КОЛИЧЕСТВА СИДЕНИЙ ХИМЧИСТКИ
    let count = 1;
    while (count <= 10) {
      this.listCountSeatsForSelect.push({ label: count, value: count });
      count++;
    }
  },
  beforeDestroy() { },

  computed: {
    BLAlert() {
      let show = (this.dataForModal?.blacklist_notification ?? '').length || this.blackListData?.isBlacklisted;
      return show ?
        (this.dataForModal?.blacklist_notification ?? this.blackListData?.message ?? false) :
        false;
    },
    // ПРОВЕРИТЬ БОЛЬШЕ ЛИ ДАТА ПОСЛЕДНЕГО ОБНОВЛЕНИЯ ОДОМЕТРА 7 ДНЕЙ
    computedDateOdometr() {
      let diffByDateOdometr = this.$time(new Date()).diff(
        this.dataForModal.contracts__odometr_end_updated_at,
        "day"
      );
      return diffByDateOdometr >= 7;
    },
    // Текущая разница одометра
    computedNumDiffOdometr() {
      return (
        this.dataForModal.contracts__odometr_end -
        this.dataForModal.contracts__odometr_start
      );
    },

    columns() {
      return [
        {
          field: "contract_calculations__name",
          key: "1636",
          title: this.dataLang["reg_contract_edit_73"],
          align: "left",
          width: "55%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "contract_calculations__count",
          key: "16326",
          title: this.dataLang["reg_contract_edit_74"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "contract_calculations__cost",
          key: "16336",
          title: this.dataLang["reg_contract_edit_75"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "contract_calculations__total",
          key: "14636",
          title: this.dataLang["reg_contract_edit_76"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },

    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>

<style lang="scss">
.contracts-blue-btn {
  border-radius: 5px;
  background-color: #0c63aa;
  padding: 6px;
  font-size: 11px;
  width: 141px;
  color: white;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}

.input-error.error-area {
  border: 1px solid #fc3304;
}

.contracts-modal-block {
  &--first {
    border-width: 0px 1px 1px 1px;
    border-style: solid;
    border-color: #cacaca;
    width: 527px;
    box-sizing: content-box;
    border-radius: 0 0 5px 5px;
  }

  &__additional-desc {
    padding: 8.5px 10px;
    font-size: 11px;
  }

  &__body {
    padding: 8px 15px;
  }

  &__header {
    padding: 8px 15px;
    font-size: 12px;
    font-weight: 800;
  }

  &__header--reserved,
  &__header--archive {
    background-color: #e7e7e7;
  }

  &__header--run {
    background-color: #23b14d;
  }

  &__header--nomoney {
    background-color: #f5b704;
  }

  &__header--blocked {
    background-color: #FF3A20;
  }

  &__header--return {
    background-color: #674000;
  }

  &--first &__body {
    padding: 0 10px;
  }

  &--first &__header {
    text-align: center;
  }

  &--first &__content {
    padding-top: 7px;
  }

  &--start-rent,
  &--end-rent,
  &--comments {
    border-width: 1px;
    border-radius: 0 0 5px 5px;
    border-style: solid;
  }

  &--start-rent &__body,
  &--end-rent &__body {
    padding: 5px 5px 10px 5px;
  }

  &--start-rent &__header {
    background-color: #0c63aa;
  }

  &--end-rent &__header {
    background-color: #23b14d;
  }

  &--start-rent {
    border-color: #0c63aa;
    background-color: #e3f0ff;
  }

  &--end-rent {
    border-color: #23b14d;
    background-color: #e8feee;
  }

  &--start-rent &__header,
  &--end-rent &__header {
    text-align: center;
    color: white;
  }

  &--comments {
    border-color: #cacaca;
  }

  &--comments &__header {
    background-color: #f6ee25;
  }

  &--comments &__body {
    padding: 15px 8px;
  }
}
</style>
